import { styled, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { FlexRow, Button, Spacer } from "../../components";
import { ColorsCodeType } from "../../typings";
import { Add } from "@mui/icons-material";
import CreateTransactionModal from "./CreateTransactionModal";
import { TRANSACTION_INITIAL_VALUES } from "../../data/transactions";

const Wrapper = styled(FlexRow)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px 15px 0px;
`;

export const StyledPrimaryButton = styled(Button)`
  min-width: 0;
  min-height: 32px;
  padding: 0px 10px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.colors.gray["900"]};
`;

interface TransactionScreenHeaderProps {
  onTransactionCreated?: () => void;
}

const TransactionScreenHeader: React.FC<TransactionScreenHeaderProps> = ({ onTransactionCreated }) => {
  const theme = useTheme();
  const {
    palette: { colors },
  } = theme;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleTransactionSuccess = () => {
    handleCloseModal();
    if (onTransactionCreated) {
      onTransactionCreated();
    }
  };

  return (
    <Wrapper>
      <Typography
        variant="h4"
        gutterBottom
        component="div"
        sx={{ fontWeight: "bold", color: "primary.main" }}
      >
        Transactions Dashboard
      </Typography>
      <StyledPrimaryButton
        buttonColor={colors["yellow"]["300"] as ColorsCodeType}
        onClick={handleOpenModal}
      >
        <Add fontSize="small" />
        <Spacer horizontal={0.3} />
        {"Create Transaction"}
      </StyledPrimaryButton>
      <CreateTransactionModal
        open={isModalOpen}
        onClose={handleCloseModal}
        transaction={TRANSACTION_INITIAL_VALUES}
        onSuccess={handleTransactionSuccess}
      />
    </Wrapper>
  );
};

export default TransactionScreenHeader;
